"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markdownToEditorState = exports.editorStateToMarkdown = exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _bold = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/bold.svg"));
var _clear = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/clear.svg"));
var _image = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/image.svg"));
var _italic = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/italic.svg"));
var _link = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/link.svg"));
var _listOrdered = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/list-ordered.svg"));
var _listUnordered = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/glyphs/list-unordered.svg"));
var _markdown = require("@catalytic/catalytic-icons/lib/glyphs/markdown.svg");
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _draftJs = require("draft-js");
var _draftJsExportMarkdown = require("draft-js-export-markdown");
var _draftJsImportMarkdown = require("draft-js-import-markdown");
var _reactDraftWysiwyg = require("react-draft-wysiwyg");
require("react-draft-wysiwyg/dist/react-draft-wysiwyg.css");
var _locale = require("../../const/locale");
var _FieldReferenceListItem = _interopRequireDefault(require("../../Input/FieldReferenceInput/FieldReferenceListItem"));
var _MultiSelectInput = _interopRequireDefault(require("../../Input/MultiSelectInput/MultiSelectInput"));
var _TextareaInput = _interopRequireDefault(require("../../Input/TextareaInput/TextareaInput"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*:: import type { ThemeType } from '../../style/ThemeTypes';*/
/*:: import { type FieldSuggestion } from '../FieldReferenceInput/FieldReferenceInput';*/
var HANDLEBAR_ENTITY_NAME = 'HANDLEBAR_ENTITY';
var HANDLEBAR_REGEX = /{{([a-zA-Z0-9-_.]+)}}/g;
// Non-printing character used to build a placeholder that markdown parsers
// cannot mistake for markdown syntax (see protectHandlebarValuesFromMarkdown).
var INVISIBLE_SEPARATOR_CHARACTER = '⁣';
var HANDLEBAR_PLACEHOLDER_REGEX = /⁣H(\d+)⁣/g;
var ZERO_WIDTH_SPACE_CHARACTER = "\u200B";
var EDITOR_MIN_HEIGHT_REM = 10;
var EDITOR_MAX_HEIGHT_REM = 25;
var DEFAULT_TOOLBAR_HEIGHT_REM = 5.5; // Height of the toolbar at 2 lines as shown by default

// react-draft-wysiwyg uses a primitive striing match to determine which set of
// translations to use. That library only has support for things like "en" and
// not "en-us", so this strips off any locale subtags, figuring that
// region-unaware translations in the right language are better than nothing.
var EDITOR_LOCALE = _locale.LOCALE.split('-')[0].toLowerCase();
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    // Update markdown rendering to match our theme's styles
    editor: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputPadding), theme.typography.baseText), {}, {
      maxHeight: "".concat(EDITOR_MAX_HEIGHT_REM, "rem"),
      minHeight: "".concat(EDITOR_MIN_HEIGHT_REM, "rem"),
      paddingTop: 0,
      whiteSpace: 'pre-line',
      '& .DraftEditor-editorContainer': {
        zIndex: 'inherit'
      },
      '& .public-DraftStyleDefault-block': {
        marginTop: '1rem'
      },
      '& h1': theme.typography.header1,
      '& h2': theme.typography.header2,
      '& h3': theme.typography.header3,
      '& h4': theme.typography.header4,
      '& h5': theme.typography.header5,
      '& h6': theme.typography.header6,
      '& h1,h2,h3,h4,h5,h6': {
        margin: '1rem 0 0.5rem',
        '& .public-DraftStyleDefault-block': {
          margin: 0
        }
      },
      '& li': {
        '& .public-DraftStyleDefault-block': {
          margin: 0
        }
      },
      '& ol, ul': {
        marginLeft: '1rem'
      }
    }),
    error: {
      '&, &:focus, &:hover': {
        border: "1px solid ".concat(theme.colors.dullRed, " !important")
      }
    },
    handlebar: {
      '& > span': {
        background: "".concat(theme.colors.highlightAlpha, " !important"),
        borderRadius: '0.15rem'
      }
    },
    hidden: {
      display: 'none'
    },
    markdownContainer: {
      '& > div:last-child': {
        bottom: '0rem',
        top: 'inherit'
      }
    },
    markdownEditor: {
      maxHeight: "".concat(EDITOR_MAX_HEIGHT_REM + DEFAULT_TOOLBAR_HEIGHT_REM, "rem"),
      minHeight: "".concat(EDITOR_MIN_HEIGHT_REM + DEFAULT_TOOLBAR_HEIGHT_REM, "rem")
    },
    root: {
      position: 'relative'
    },
    toolbar: {
      backgroundColor: theme.colors.blueGrey,
      borderBottom: "1px solid ".concat(theme.colors.lightGrey),
      borderTopLeftRadius: '0.5rem',
      borderTopRightRadius: '0.5rem',
      marginBottom: 0,
      paddingBottom: '0.125rem',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem',
      paddingTop: '0.5rem',
      '& .rdw-image-modal, & .rdw-link-modal': _objectSpread(_objectSpread({}, theme.mixins.inputMenu), {}, {
        borderRadius: '0.25rem',
        top: '2.5rem',
        '& .rdw-image-modal-btn, & .rdw-link-modal-btn': {
          borderRadius: '0.25rem',
          '&:first-of-type': {
            backgroundColor: theme.colors.scienceBlue,
            borderColor: theme.colors.scienceBlue,
            color: theme.colors.white
          },
          '&:hover': {
            boxShadow: 'none'
          }
        }
      }),
      '& .rdw-link-modal-target-option': {
        display: 'none'
      },
      '& .rdw-option-wrapper': {
        background: 'none',
        border: 'none',
        height: '2rem',
        margin: '0 0.75rem 0 0',
        width: '2rem',
        '& img': {
          height: '1rem',
          width: '1rem'
        }
      },
      '& .rdw-option-active, & .rdw-option-wrapper:hover': {
        backgroundColor: theme.colors.ghostWhite,
        border: "1px solid ".concat(theme.colors.lightGrey),
        borderRadius: theme.variables.borderRadiusSmall,
        boxShadow: 'none'
      },
      '& .rdw-image-modal-size': {
        display: 'none'
      }
    },
    // Toggle to switch between markdown and editor views
    viewToggle: _objectSpread(_objectSpread({}, theme.typography.extraExtraSmallText), {}, {
      color: theme.colors.ashGrey,
      fill: theme.colors.ashGrey,
      outline: 'none',
      position: 'absolute',
      right: 0,
      '& svg': {
        fontSize: '1.25rem',
        marginBottom: '-0.0625rem',
        paddingRight: '0.25rem',
        verticalAlign: 'bottom'
      }
    }),
    viewToggleContainer: {
      height: '1rem',
      position: 'relative'
    },
    wrapper: _objectSpread(_objectSpread({}, theme.mixins.inputStyle), {}, {
      borderWidth: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0
    })
  };
});

// Parse current content and replace handlebar blocks showing display names
// with the handlebar reference. E.g. Foo 1 => {{foo-1}}
var replaceBlockHandlebarLabelsWithValues = function replaceBlockHandlebarLabelsWithValues(contentBlock /*: ContentBlock*/, contentState /*: ContentState*/) /*: ContentState*/{
  var isHandlebarEntityRange = function isHandlebarEntityRange(character) {
    var entityKey = character.getEntity();
    if (entityKey != null && contentState.getEntity(entityKey).getType() === HANDLEBAR_ENTITY_NAME) {
      return true;
    }
    return false;
  };
  var blockKey = contentBlock.getKey();
  var instanceLocations = [];
  contentBlock.findEntityRanges(isHandlebarEntityRange, function (start, end) {
    instanceLocations.push({
      start: start,
      end: end
    });
  });
  instanceLocations.reverse().forEach(function (_ref) {
    var start = _ref.start,
      end = _ref.end;
    var entityKey = contentBlock.getEntityAt(start);
    if (entityKey != null) {
      var entity = contentState.getEntity(entityKey);
      var selection = new _draftJs.SelectionState({
        anchorKey: blockKey,
        anchorOffset: start,
        focusKey: blockKey,
        focusOffset: end
      });
      var inlineStyle = contentBlock.getInlineStyleAt(start);
      contentState = _draftJs.Modifier.replaceText(contentState, selection, entity.data.value, inlineStyle, null);
    }
  });
  return contentState;
};
var selectionStateForBlock = function selectionStateForBlock(contentBlock /*: ContentBlock*/) {
  var blockKey = contentBlock.getKey();
  return new _draftJs.SelectionState({
    anchorKey: blockKey,
    focusKey: blockKey,
    focusOffset: 0,
    hasFocus: true
  });
};

// Replace block types that aren't mapped correctly when translating to
// markdown. Currently maps code entities to code-blocks.
var adjustBlockTypeToMarkdown = function adjustBlockTypeToMarkdown(contentBlock /*: ContentBlock*/, contentState /*: ContentState*/) /*: ContentState*/{
  if (contentBlock.getType() === 'code') {
    var selectionState = selectionStateForBlock(contentBlock);
    contentState = _draftJs.Modifier.setBlockType(contentState, selectionState, 'code-block');
  }
  return contentState;
};

// Replace block types that aren't mapped correctly when translating to
// editor state from markdown. Currently maps code-blocks to code entities.
var adjustBlockTypeFromMarkdown = function adjustBlockTypeFromMarkdown(contentBlock /*: ContentBlock*/, contentState /*: ContentState*/) /*: ContentState*/{
  if (contentBlock.getType() === 'code-block') {
    var selectionState = selectionStateForBlock(contentBlock);
    contentState = _draftJs.Modifier.setBlockType(contentState, selectionState, 'code');
    contentState = _draftJs.Modifier.removeInlineStyle(contentState, selectionState, 'CODE');
  }
  return contentState;
};

// Parse markdown content and replace handlebar references with blocks that
// show field display names. E.g. {{foo-1}} => Foo 1
var replaceBlockHandlebarValuesWithLabels = function replaceBlockHandlebarValuesWithLabels(contentBlock /*: ContentBlock*/, contentState /*: ContentState*/, fieldOptions /*: Array<FieldSuggestion>*/) /*: ContentState*/{
  var blockKey = contentBlock.getKey();
  var text = contentBlock.getText();
  // Use exec because IE11 does not support matchAll
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll#regexp.exec_and_matchall
  var matches = [];
  var match;
  while ((match = HANDLEBAR_REGEX.exec(text)) !== null) {
    matches.push(match);
  }
  matches.reverse().forEach(function (match /*: Object*/) {
    var value = match[0];
    var start = match.index;
    var end = start + value.length;
    var selection = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: start,
      focusKey: blockKey,
      focusOffset: end
    });
    var matchingField = fieldOptions.find(function (f) {
      return f.id === value;
    });
    var label = (matchingField === null || matchingField === void 0 ? void 0 : matchingField.display) ? matchingField === null || matchingField === void 0 ? void 0 : matchingField.display : value;
    contentState = contentState.createEntity(HANDLEBAR_ENTITY_NAME, 'IMMUTABLE', {
      label: label,
      value: value
    });
    var inlineStyle = contentBlock.getInlineStyleAt(start);
    var entityKey = contentState.getLastCreatedEntityKey();
    contentState = _draftJs.Modifier.replaceText(contentState, selection, label || '', inlineStyle, entityKey);
  });
  return contentState;
};

// Replace every {{handlebar}} match in raw markdown with a placeholder that
// cannot be misinterpreted as markdown syntax (e.g. emphasis) by the
// underlying markdown parser. The original matched strings are returned
// alongside so they can be restored after parsing, before handlebar values
// are turned into entities. See restoreHandlebarPlaceholders.
var protectHandlebarValuesFromMarkdown = function protectHandlebarValuesFromMarkdown(markdown /*: string*/) /*: { protectedMarkdown: string, tokens: Array<string> }*/{
  var tokens = [];
  var protectedMarkdown = markdown.replace(HANDLEBAR_REGEX, function (match) {
    var index = tokens.length;
    tokens.push(match);
    return "".concat(INVISIBLE_SEPARATOR_CHARACTER, "H").concat(index).concat(INVISIBLE_SEPARATOR_CHARACTER);
  });
  return {
    protectedMarkdown: protectedMarkdown,
    tokens: tokens
  };
};

// Parse content and replace handlebar placeholders (inserted by
// protectHandlebarValuesFromMarkdown) with the original raw handlebar text,
// as plain entity-free text. Mirrors replaceBlockHandlebarValuesWithLabels.
var restoreHandlebarPlaceholders = function restoreHandlebarPlaceholders(contentBlock /*: ContentBlock*/, contentState /*: ContentState*/, tokens /*: Array<string>*/) /*: ContentState*/{
  var blockKey = contentBlock.getKey();
  var text = contentBlock.getText();
  // Use exec because IE11 does not support matchAll
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/matchAll#regexp.exec_and_matchall
  var matches = [];
  var match;
  while ((match = HANDLEBAR_PLACEHOLDER_REGEX.exec(text)) !== null) {
    matches.push(match);
  }
  matches.reverse().forEach(function (match /*: Object*/) {
    var start = match.index;
    var end = start + match[0].length;
    var selection = new _draftJs.SelectionState({
      anchorKey: blockKey,
      anchorOffset: start,
      focusKey: blockKey,
      focusOffset: end
    });
    var inlineStyle = contentBlock.getInlineStyleAt(start);
    contentState = _draftJs.Modifier.replaceText(contentState, selection, tokens[Number(match[1])], inlineStyle, null);
  });
  return contentState;
};

// Parse raw markdown into a ContentState, protecting {{handlebar}} references
// from being misinterpreted as markdown syntax (e.g. emphasis) by the
// underlying markdown parser, then turning them into HANDLEBAR_ENTITY blocks.
var parseMarkdownToContentState = function parseMarkdownToContentState(markdown /*: string*/, fieldOptions /*: Array<FieldSuggestion>*/) /*: ContentState*/{
  var _protectHandlebarValu = protectHandlebarValuesFromMarkdown(markdown),
    protectedMarkdown = _protectHandlebarValu.protectedMarkdown,
    tokens = _protectHandlebarValu.tokens;
  var contentState = (0, _draftJsImportMarkdown.stateFromMarkdown)(protectedMarkdown, {
    parserOptions: {
      atomicImages: true,
      breaks: true
    }
  });
  contentState.getBlocksAsArray().forEach(function (contentBlock) {
    contentState = restoreHandlebarPlaceholders(contentBlock, contentState, tokens);
  });
  contentState.getBlocksAsArray().forEach(function (contentBlock) {
    contentState = replaceBlockHandlebarValuesWithLabels(contentBlock, contentState, fieldOptions);
  });
  return contentState;
};

// Translate raw markdown to draft.js EditorState structure
var markdownToEditorState = exports.markdownToEditorState = function markdownToEditorState(markdown /*: string*/, fieldOptions /*: Array<FieldSuggestion>*/) /*: EditorState*/{
  var contentState = parseMarkdownToContentState(markdown, fieldOptions);
  contentState.getBlocksAsArray().forEach(function (contentBlock) {
    contentState = adjustBlockTypeFromMarkdown(contentBlock, contentState);
  });
  return _draftJs.EditorState.createWithContent(contentState);
};

// Translate draft.js EditorState structure to raw markdown
var editorStateToMarkdown = exports.editorStateToMarkdown = function editorStateToMarkdown(editorState /*: EditorState*/) /*: string*/{
  var contentState = editorState.getCurrentContent();
  contentState.getBlocksAsArray().forEach(function (contentBlock) {
    contentState = replaceBlockHandlebarLabelsWithValues(contentBlock, contentState);
    contentState = adjustBlockTypeToMarkdown(contentBlock, contentState);
  });
  // Pass the `gfm: true` option to make it translate code blocks correctly.
  // This flag stands for "GitHub-Flavored Markdown" and is only currently used
  // for branching whether code blocks are expressed using tabs or ```.
  var markdown = (0, _draftJsExportMarkdown.stateToMarkdown)(contentState, {
    gfm: true
  });
  return markdown.trim()
  // Prevent underscores from being escaped with a backslash
  .replace(/\\_/g, '_')
  // Remove non-visible character artifact from markdown translation
  .replace(ZERO_WIDTH_SPACE_CHARACTER, '');
};
var useSelectBlockTypeStyles = (0, _styles.makeStyles)({
  root: {
    flexBasis: '9rem',
    marginBottom: '0.375rem',
    marginRight: '0.75rem'
  }
});
var SelectBlockType = function SelectBlockType(props
/*: {
  currentState: { blockType: string },
  onChange: string => mixed
}*/
) {
  var currentState = props.currentState,
    _onChange = props.onChange;
  var classes = useSelectBlockTypeStyles();
  var options = [{
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Normal text",
      id: "MarkdownInput.blockType.Normal"
    }),
    value: 'Normal'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 1",
      id: "MarkdownInput.blockType.H1"
    }),
    value: 'H1'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 2",
      id: "MarkdownInput.blockType.H2"
    }),
    value: 'H2'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 3",
      id: "MarkdownInput.blockType.H3"
    }),
    value: 'H3'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 4",
      id: "MarkdownInput.blockType.H4"
    }),
    value: 'H4'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 5",
      id: "MarkdownInput.blockType.H5"
    }),
    value: 'H5'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Header 6",
      id: "MarkdownInput.blockType.H6"
    }),
    value: 'H6'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Blockquote",
      id: "MarkdownInput.blockType.Blockquote"
    }),
    value: 'Blockquote'
  }, {
    label: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Code",
      id: "MarkdownInput.blockType.Code"
    }),
    value: 'Code'
  }];
  return /*#__PURE__*/React.createElement(_MultiSelectInput.default, {
    className: classes.root,
    "data-testid": "select-blocktype",
    embedded: true,
    isClearable: false,
    isMulti: false,
    onChange: function onChange(e) {
      return _onChange(e.currentTarget.value[0]);
    },
    options: options,
    value: options.find(function (o) {
      return o.value === (currentState === null || currentState === void 0 ? void 0 : currentState.blockType);
    }) || options[0]
  });
};
var useInsertFieldStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    root: {
      flexBasis: '12rem',
      flexGrow: '1',
      marginBottom: '0.375rem',
      maxWidth: '20rem',
      minWidth: '12rem'
    },
    input: {
      '& .MultiSelectInput__placeholder': _objectSpread(_objectSpread({}, theme.mixins.truncate), {}, {
        maxWidth: '100%'
      })
    }
  };
});
var InsertField = function InsertField(props
/*: {
  editorState: EditorState,
  onChange: EditorState => mixed,
  fieldOptions: Array<FieldSuggestion>
}*/
) {
  var editorState = props.editorState,
    _onChange2 = props.onChange,
    fieldOptions = props.fieldOptions;
  var classes = useInsertFieldStyles();
  if (!fieldOptions) {
    return null;
  }
  var parseOptionFromTarget = function parseOptionFromTarget(currentTarget) {
    var fieldName = currentTarget.value[0];
    var matchingField = fieldOptions.find(function (f) {
      return f.id === fieldName;
    });
    var displayName = (matchingField === null || matchingField === void 0 ? void 0 : matchingField.display) ? matchingField === null || matchingField === void 0 ? void 0 : matchingField.display : fieldName;
    return {
      label: displayName,
      value: fieldName
    };
  };
  return /*#__PURE__*/React.createElement(_MultiSelectInput.default, {
    className: classes.root,
    inputClassName: classes.input,
    "data-testid": "insert-field",
    embedded: true,
    isClearable: false,
    isMulti: false,
    onChange: function onChange(e) {
      var option = parseOptionFromTarget(e.currentTarget);
      var contentStateWithEntity = editorState.getCurrentContent().createEntity(HANDLEBAR_ENTITY_NAME, 'IMMUTABLE', option);
      var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
      var contentState = editorState.getCurrentContent();
      var selection = editorState.getSelection();
      if (!selection.isCollapsed()) {
        contentState = _draftJs.Modifier.removeRange(contentState, selection, 'backward');
        selection = contentState.getSelectionAfter();
      }
      var mentionInsertedContent = _draftJs.Modifier.insertText(contentState, selection, option.label || '', null, entityKey);
      var newEditorState = _draftJs.EditorState.push(editorState, mentionInsertedContent, 'insert-characters');
      _onChange2(newEditorState);
    },
    options: fieldOptions.map(function (suggestion) {
      return {
        label: /*#__PURE__*/React.createElement(_FieldReferenceListItem.default, suggestion),
        value: suggestion.id
      };
    }),
    placeholder: /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
      defaultMessage: "Insert a Field Reference...",
      id: "MarkdownInput.InsertField.label"
    }),
    value: null
  });
};
var makeHandlebarDecorators = function makeHandlebarDecorators(classes) {
  var handlebarStrategy = function handlebarStrategy(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === HANDLEBAR_ENTITY_NAME;
    }, callback);
  };
  var HandlebarSpan = function HandlebarSpan(_ref2 /*:: */) {
    var children = _ref2 /*:: */.children;
    return /*#__PURE__*/React.createElement("span", {
      className: classes.handlebar
    }, children);
  };
  return [{
    strategy: handlebarStrategy,
    component: HandlebarSpan
  }];
};
/*:: export type MarkdownInputType = {
  className?: string,
  defaultValue: string,
  disabled?: boolean,
  displayErrors?: boolean,
  fieldOptions: Array<FieldSuggestion>,
  hasError?: boolean,
  hasRequired?: boolean,
  id?: string,
  inputClassName?: string,
  name?: string,
  onChange?: ({
    currentTarget: { value: string }
  }) => mixed,
  placeholder?: string,
  readOnly?: boolean,
  required?: boolean,
  uploadFile?: (Array<File>) => Promise<Object>
};*/
function MarkdownInput(props /*: MarkdownInputType*/) {
  var className = props.className,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    displayErrors = props.displayErrors,
    fieldOptionsWithoutBraces = props.fieldOptions,
    hasError = props.hasError,
    hasRequired = props.hasRequired,
    id = props.id,
    inputClassName = props.inputClassName,
    nameProp = props.name,
    _onChange3 = props.onChange,
    placeholder = props.placeholder,
    readOnly = props.readOnly,
    required = props.required,
    uploadFile = props.uploadFile;
  var name = nameProp || 'markdown-input';
  var fieldOptions = fieldOptionsWithoutBraces.map(function (f) {
    return _objectSpread(_objectSpread({}, f), {}, {
      id: "{{".concat(f.id, "}}")
    });
  });
  var classes = useStyles();
  var intl = (0, _reactIntl.useIntl)();
  var _React$useState = React.useState(defaultValue),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    markdown = _React$useState2[0],
    setMarkdown = _React$useState2[1];
  var _React$useState3 = React.useState(markdownToEditorState(defaultValue, fieldOptions)),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    editorState = _React$useState4[0],
    setEditorState = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    isCodeView = _React$useState6[0],
    setIsCodeView = _React$useState6[1];
  var hasValue = typeof markdown === 'string' && markdown.trim().replace(ZERO_WIDTH_SPACE_CHARACTER, '').length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(classes.root, className),
    "data-testid": name
  }, !isCodeView && /*#__PURE__*/React.createElement(_reactDraftWysiwyg.Editor, {
    customDecorators: makeHandlebarDecorators(classes),
    editorClassName: classes.editor,
    editorState: editorState,
    handlePastedText: function handlePastedText(text, html, editorState) {
      // TODO: Support copying with handlebar references intact instead
      // of copying the display name like we do today.
      // See https://github.com/facebook/draft-js/issues/787#issuecomment-382547599
      var contentState = parseMarkdownToContentState(text, fieldOptions);
      var pastedBlocks = contentState.blockMap;
      var newState = _draftJs.Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), pastedBlocks);
      var newEditorState = _draftJs.EditorState.push(editorState, newState, 'insert-fragment');
      setEditorState(newEditorState);
      return true;
    },
    localization: {
      locale: EDITOR_LOCALE,
      translations: {
        'components.controls.image.byURL': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.URL',
          defaultMessage: 'URL'
        }),
        'components.controls.image.dropFileText': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.DropFileText',
          defaultMessage: 'Upload an image'
        }),
        'components.controls.image.fileUpload': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.FileUpload',
          defaultMessage: 'File Upload'
        }),
        'components.controls.image.image': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Image',
          defaultMessage: 'Image'
        }),
        'components.controls.inline.bold': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Bold',
          defaultMessage: 'Bold'
        }),
        'components.controls.inline.italic': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Italic',
          defaultMessage: 'Italic'
        }),
        'components.controls.link.link': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Link',
          defaultMessage: 'Link'
        }),
        'components.controls.link.linkTarget': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.LinkTarget',
          defaultMessage: 'Link Target'
        }),
        'components.controls.link.linkTitle': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.LinkTitle',
          defaultMessage: 'Link Title'
        }),
        'components.controls.list.ordered': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.OrderedList',
          defaultMessage: 'Ordered List'
        }),
        'components.controls.list.unordered': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.UnorderedList',
          defaultMessage: 'Unordered List'
        }),
        'components.controls.remove.remove': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.ClearFormatting',
          defaultMessage: 'Clear Formatting'
        }),
        'generic.add': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Add',
          defaultMessage: 'Add'
        }),
        'generic.cancel': intl.formatMessage({
          id: 'MarkdownInput.Toolbar.Cancel',
          defaultMessage: 'Cancel'
        })
      }
    },
    onEditorStateChange: function onEditorStateChange(editorState) {
      setEditorState(editorState);
      var newMarkdown = editorStateToMarkdown(editorState);
      // Only run this if the user made some change that impacts the
      // markdown. There are cases where the translation to editorState
      // and back to markdown make non-signicant changes (adds a newliine)
      // but those shouldn't make the value dirty or trigger onChange.
      if (newMarkdown !== markdown) {
        setMarkdown(newMarkdown);
        if (_onChange3) {
          _onChange3({
            currentTarget: {
              value: newMarkdown
            }
          });
        }
      }
    },
    placeholder: placeholder,
    readOnly: disabled || readOnly,
    toolbar: {
      options: ['blockType', 'inline', 'list', 'link', 'image', 'remove'],
      blockType: {
        component: SelectBlockType
      },
      remove: {
        icon: _clear.default
      },
      inline: {
        bold: {
          icon: _bold.default
        },
        italic: {
          icon: _italic.default
        },
        options: ['bold', 'italic']
      },
      image: {
        urlEnabled: true,
        uploadEnabled: !!uploadFile,
        alignmentEnabled: false,
        uploadCallback: function uploadCallback(value) {
          if (uploadFile) {
            return uploadFile(value).then(function (fileInfo) {
              return {
                data: {
                  link: fileInfo.url
                }
              };
            });
          }
        },
        previewImage: true,
        icon: _image.default,
        inputAccept: 'image/*',
        alt: {
          present: false,
          mandatory: false
        },
        defaultSize: {
          height: 'auto',
          width: 'auto'
        }
      },
      link: {
        link: {
          icon: _link.default
        },
        options: ['link']
      },
      list: {
        options: ['unordered', 'ordered'],
        ordered: {
          icon: _listOrdered.default
        },
        unordered: {
          icon: _listUnordered.default
        }
      }
    },
    toolbarClassName: classes.toolbar,
    toolbarCustomButtons: fieldOptions.length > 0 ? [
    /*#__PURE__*/
    // $FlowIgnore
    React.createElement(InsertField, {
      key: "insert-field",
      fieldOptions: fieldOptions
    })] : undefined,
    wrapperClassName: (0, _classnames.default)(classes.wrapper, (0, _defineProperty2.default)({}, classes.error, hasError || displayErrors && required && !hasValue), inputClassName)
  }), /*#__PURE__*/React.createElement(_TextareaInput.default, {
    className: classes.markdownContainer,
    "data-testid": "".concat(name, "-textarea"),
    disabled: disabled || readOnly,
    hasRequired: hasRequired,
    id: id || name,
    inputClassName: (0, _classnames.default)(classes.markdownEditor, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.error, hasError || displayErrors && required && !hasValue), classes.hidden, !isCodeView), inputClassName),
    name: name,
    onChange: function onChange(e) {
      var newMarkdown = e.currentTarget.value;
      var newState = markdownToEditorState(newMarkdown, fieldOptions);
      setMarkdown(newMarkdown);
      setEditorState(newState);
      if (_onChange3) {
        _onChange3(_objectSpread(_objectSpread({}, e), {}, {
          currentTarget: _objectSpread(_objectSpread({}, e.currentTarget), {}, {
            value: newMarkdown
          })
        }));
      }
    },
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    value: markdown
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.viewToggleContainer
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.viewToggle,
    "data-testid": "".concat(name, "-view-toggle"),
    onClick: function onClick(e) {
      e.preventDefault();
      setIsCodeView(!isCodeView);
    }
  }, /*#__PURE__*/React.createElement(_markdown.ReactComponent, null), isCodeView ? /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Show Editor",
    id: "MarkdownInput.ViewToggle.Editor"
  }) : /*#__PURE__*/React.createElement(_reactIntl.FormattedMessage, {
    defaultMessage: "Show Markdown",
    id: "MarkdownInput.ViewToggle.Markdown"
  }))));
}
MarkdownInput.displayName = 'MarkdownInput';
var _default = exports.default = MarkdownInput;
//# sourceMappingURL=MarkdownInput.js.map